document.addEventListener("DOMContentLoaded", function () {
    const menuItems = document.querySelectorAll(".header__menu-item");
        menuItems.forEach((item) => {
        const details = item.closest("details");
            if (details) {
            item.addEventListener("mouseenter", function () {
                details.setAttribute("open", "true");
            });
            details.addEventListener("mouseleave", function () {
                details.removeAttribute("open");
            });
            }
    });
});